/**
 * Configure video component
 */

window.onscroll = function () {
  scrollPage();
  railSticky();
};

function scrollPage() {
  const scrollButton = document.querySelector('#scroll_button');
  if (scrollButton) {
    if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
      scrollButton.style.display = 'block';
    } else {
      scrollButton.style.display = 'none';
    }
  }
}

function scrolltoTop() {
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
}

function railSticky() {
  var railLayout = document.querySelector('.left_rail_wrapper');
  if (railLayout) {
    var sticky = railLayout.offsetTop - 1;
    if (window.pageYOffset >= sticky) {
      railLayout.classList.add('stick');
    } else {
      railLayout.classList.remove('stick');
    }
  }
}

export { scrolltoTop, railSticky };
